/* Roast Row delivery estimate (mirror of shared/delivery.py). Uses only warehouse + carrier data from the
   product's metafield; never promises a date the data does not support. No personal data is stored. */
(function () {
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var REGION = { 'Alaska': 'AK', 'Hawaii': 'HI', 'Puerto Rico': 'PR', 'Guam': 'GU', 'Virgin Islands': 'VI' };

  function partsIn(tz) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false });
    var o = {}; f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), minutes: (+o.hour % 24) * 60 + (+o.minute) };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isBiz(d, hol) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && hol.indexOf(iso(d)) === -1; }
  function addBiz(d, n, hol) { d = new Date(d); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isBiz(d, hol)) n--; } return d; }
  function fmt(d) { return DOW[d.getUTCDay()] + ', ' + MON[d.getUTCMonth()] + ' ' + d.getUTCDate(); }

  function render(el, cfg, region) {
    var country = (el.getAttribute('data-country') || 'US').toUpperCase();
    var market = country === 'GB' ? 'UK' : country;
    var m = (cfg.markets || {})[market];
    var text = el.querySelector('[data-rr-delivery-text]'), note = el.querySelector('[data-rr-delivery-note]');
    if (!m || !m.origin || !m.transit) { return; }      // keep the fallback text
    var hol = cfg.holidays || [], now = partsIn(cfg.tz || 'America/Los_Angeles');
    var cut = (cfg.cutoff || '12:00').split(':'), start = now.date;
    if (now.minutes >= (+cut[0]) * 60 + (+cut[1]) || !isBiz(start, hol)) start = addBiz(start, 1, hol);
    var proc = (cfg.processing || {})[m.origin]; if (proc == null) proc = (cfg.processing || {})['default'] || 2;
    var extra = market === 'US' ? ((cfg.extra_region || {})[region] || 0) : 0;
    var shipped = proc ? addBiz(start, proc, hol) : start;
    var a = addBiz(shipped, m.transit[0] + extra, hol), b = addBiz(shipped, m.transit[1] + extra, hol);
    var domestic = m.origin === (market === 'UK' ? 'GB' : market);
    var fast = domestic && (proc + m.transit[1] + extra) <= (cfg.fast_max || 4);
    text.innerHTML = 'Arrives ' + fmt(a) + (iso(a) === iso(b) ? '' : ' – ' + fmt(b)) + (fast ? '<span class="rr-fast">Fast delivery</span>' : '');
    var from = { US: 'the US', CN: 'China', GB: 'the UK', CA: 'Canada' }[m.origin] || m.origin;
    note.textContent = 'Ships from our partner warehouse in ' + from + '. Order before ' + (cfg.cutoff || '12:00') + ' PT on a business day.';
  }

  function init() {
    var el = document.querySelector('[data-rr-delivery]'); if (!el) return;
    var cfg; try { cfg = JSON.parse(el.getAttribute('data-rr-delivery')); } catch (e) { return; }
    render(el, cfg, null);
    // Only the region matters (Alaska/Hawaii/territories add days). Lightweight lookup, 1.5 s budget, nothing stored.
    if ((el.getAttribute('data-country') || 'US').toUpperCase() !== 'US' || !window.fetch) return;
    var ctl = window.AbortController ? new AbortController() : null;
    if (ctl) setTimeout(function () { ctl.abort(); }, 1500);
    fetch('https://get.geojs.io/v1/ip/geo.json', ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (g) { var reg = REGION[g.region]; if (reg) render(el, cfg, reg); })
      .catch(function () {});
  }
  if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 1200 }); else setTimeout(init, 300);
})();
